<template lang="">
  <div>
    <slot></slot>
  </div>
</template>

<script setup>
import { inject, provide, onUnmounted, onMounted, watch, computed } from 'vue'
import MapboxVectorLayer from 'ol/layer/MapboxVector'
import VectorLayer from 'ol/layer/Vector'
import Vector from 'ol/source/Vector'

const props = defineProps({
  styleUrl: {
    type: String,
    required: true,
  },
  accessToken: {
    type: String,
    required: true,
  },
})

const attributionLayer = new VectorLayer({
  source: new Vector({
    attributions:
      '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a> <a href="https://www.mapbox.com/map-feedback/" target="_blank">Improve this map</a>',
  }),
})

const map = inject('map')
const overViewMap = inject('overviewMap', null)

const tileLayer = computed(
  () =>
    new MapboxVectorLayer({
      styleUrl: props.styleUrl,
      accessToken: props.accessToken,
      zIndex: 1,
    })
)

const applyTileLayer = () => {
  if (overViewMap != null) {
    overViewMap.value.getOverviewMap().addLayer(tileLayer.value)
    overViewMap.value.changed()
  } else {
    map.addLayer(tileLayer.value)
    map.addLayer(attributionLayer)
  }
}

const removeTileLayer = () => {
  if (overViewMap != null) {
    overViewMap.value.getOverviewMap().removeLayer(tileLayer.value)
    overViewMap.value.changed()
  } else {
    map.removeLayer(tileLayer.value)
    map.removeLayer(attributionLayer)
  }
}

if (overViewMap != null) {
  watch(overViewMap, () => {
    removeTileLayer()
    applyTileLayer()
  })
}

onMounted(() => {
  applyTileLayer()
})

onUnmounted(() => {
  removeTileLayer()
})

provide('tileLayer', tileLayer)
</script>

<style lang=""></style>
